import React,{useMemo,useEffect,useState} from 'react'
import { DownloadAbleTable,SelectColumnFilter, DateRangeColumnFilter} from '../../../components/Table/DownloadAbleTable';
import Utils from '../../../library/Utils';
import { useDispatch, useSelector} from 'react-redux';
import { Link } from 'react-router-dom'
import { selectLoanState } from '../../../redux/Slices/Loan';
import { FetchDataStatus } from '../../../library/Variables';
import Spinner from '../../../svg/Spinner/Spinner';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getFilteredLoan } from '../../../redux/Slices/Loan';
import { downLoadAdminReport } from '../../../redux/Slices/Loans/LoanManagement/LoanManagement';
import { resetLoanFileData,resetLoanVerifiedData,resetApproval } from '../../../redux/Slices/LoanFile';
import { resetCustomDecisionCreditScore } from '../../../redux/Slices/CustomDecisionCustomCreditScore';
import { resetLoanScore } from '../../../redux/Slices/LoanScores';
import LoanManagement from '../../../redux/Slices/Loans/LoanManagement/LoanManagement';
import docDownload from '../../../assests/icons/docDownload.png'

function LoanManagementRecords({setAgentModal,accessToken,user,setLoanKey}) {
    let content;
    const dispatch = useDispatch()
    let tableData = [];
    const permissions = user.user.permissions
    const loanState = useSelector(selectLoanState)
    const [applicationKeys,setApplicationKeys] = useState([])
    const [mainContent,setMainContent] = useState(<Spinner/>)

    useEffect(()=>{
      if(loanState.loanFilterStatus === FetchDataStatus.INITIAL){
        dispatch(getFilteredLoan({accessToken,filter:'submitted'}))
      }

    },[loanState.loanFilterStatus])


    const submitLoanKeys = ()=>{
        dispatch(downLoadAdminReport({accessToken,data:{loanApplicationKey:applicationKeys}}))
    }


    const theadersStatements = useMemo(() => [
        
        {
            Cell: data => {
              let branchName = data.row.original.branch;
              branchName = !Utils.isFieldEmpty(branchName)?branchName:'---' 
              return (
                <span>
                  {branchName}
                </span>
              );
            },
            Header: 'Branch Name',
            accessor: 'branch',
          },
        { 
            Header: 'Agent Name',
            accessor: 'agentName'
          },
          { 
            Header: 'Applicant Name',
            accessor: 'name'
          },
        { 
          Cell: data => {
            let statusDisplay = data.row.original.createdDate;
            statusDisplay = Utils.formatLongDateMonthAndYear(statusDisplay)
            return (
              <span>
                {statusDisplay}
              </span>
            );
          },
          Header: 'Submitted Date',
          accessor: 'createdDate',
          Filter: DateRangeColumnFilter,
          filter: 'dateRange'
        },
        {
          Cell: data => {
            let dateUpdate = data.row.original.updatedDate;
            dateUpdate = dateUpdate==='--'? '--': Utils.formatLongDateMonthAndYear(dateUpdate)
            return (
              <span>
                {dateUpdate}
              </span>
            );
          },
          Header: 'Updated Date',
          accessor: 'updatedDate',
          Filter: DateRangeColumnFilter,
          filter: 'dateRange'
        },
       
        {
          id: 'button-column',
          disableSortBy: true,
          Cell: data => {
            const keyVal = data.row.original.key;
            return (
              <div onClick={()=>{setLoanKey(keyVal);setAgentModal(true)}} style={{backgroundColor:'rgba(64, 123, 255, 1)',cursor:"pointer",display:"flex",alignItems:'center',justifyContent:"center",color:'white',padding:'10px 0px',borderRadius:'4px',textAlign:'center'}}>
                <span state={{ key: data.row.original.key }} style={{display:"flex",color:'white',width:'80px',textDecoration:'none',alignItems:"center",justifyContent:"center"}} >Re-assign</span>
              </div>
            );
          }
        }]
      )


      useEffect(()=>{
        if(loanState.loanFilterStatus === FetchDataStatus.INITIAL){
            content = <Spinner/>
            setMainContent(content)
        }
        if(loanState.loanFilterStatus === FetchDataStatus.FETCHING){
            content = <Spinner/>
            setMainContent(content)
        }

        if(loanState.loanFilterStatus === FetchDataStatus.SUCCESS){
            loanState.loanFilterData.forEach(form => {
                tableData.push({
                  key: form.key,
                  name: form.name,
                  agentName: form.agentName,
                  createdDate: form.createdDate,
                  branch:form.branch,
                  clientId:form.clientId,
                  updatedDate: !Utils.isFieldEmpty(form.updatedDate) ? form.updatedDate : "--",
                  status: form.status
                })
              })
            content = <DownloadAbleTable tableClass="statement-type-table" pagination={true} pageSize={[10]} data={tableData} 
                        columns={theadersStatements}
                        tableExtra={false} tableFilter={true} setApplicationKeys={setApplicationKeys} />;
            setMainContent(content)
        }
      },[loanState.loanFilterStatus])

  return (
    <div>
        <section style={{display:"flex",alignItems:"center",width:"95%",justifyContent:"space-between",margin:"25px auto"}}>
            <p style={{fontWeight:"700"}}>Loan Activities</p>
            <div onClick={()=>submitLoanKeys()} style={{display:"flex",width:"250px",cursor:"pointer",color:"white",padding:"15px 0px",borderRadius:"10px",justifyContent:"space-around",alignItems:"center",backgroundColor:'#2A38A4'}}>
                <span style={{display:"flex",justifyContent:"space-around",alignItems:"center"}}>
                    <img src={docDownload}/>
                </span>
                <span>Download Loan Report</span>
            </div>
        </section>
        {mainContent}
    </div>
  )
}

export default LoanManagementRecords